<template>
  <!-- NOTE (TEMPLATE) to register a new proposal -->

  <div class="animated fadeIn">
    <!-- loading component -->
    <Loading />
    <b-card
      v-if="$router.currentRoute.path == '/researcher/newMasterThesis'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <b-tabs class="mb-3" pills vertical v-model="tabIndex">
        <div class="d-flex justify-content-center mt-3"></div>
        <b-tab :title="'حمایت های پیشین از پایان‌نامه کارشناسی ارشد'" active>
          <b-form-group>
            <div class="d-flex" dir="ltr">
              <label
                for="switch_1"
                :class="
                  initial.initialObligation
                    ? 'ml-3 mb-0 done'
                    : 'ml-3 mb-0 required'
                "
              >
                اینجانب تعهد می کنم با مطالعه و آگاهی از
                <b-button
                  id="downLoad"
                  title="دانلود تعهدات"
                  variant="link"
                  href="/researcher/rules/master/شیوه نامه پایان نامه ارشد.pdf"
                >
                  <b-tooltip
                    placement="bottomleft"
                    target="downLoad"
                    triggers="hover"
                    variant="info"
                    >دانلود شیوه‌نامه</b-tooltip
                  >شیوه‌نامه حمایت از پایان‌نامه‌های کارشناسی ارشد ستاد توسعه
                  زیست فناوری </b-button
                >و طرح تقسیم کار ملی زیست‌فناوری نسبت به ارسال درخواست در سامانه
                اقدام می نمایم
              </label>
              <b-form-checkbox
                id="switch_1"
                v-model="initial.initialObligation"
              ></b-form-checkbox>
            </div>
          </b-form-group>
          <hr />
          <h3 class="text-primary mb-4">دانشجو گرامی</h3>

          <!-- <b-form-group>
            <b-form-checkbox
             
              :class="initial.initialObligation ? 'done' : 'required'"
              v-model="initial.initialObligation"
            >اینجانب تعهد می کنم با مطالعه و آگاهی از دستورالعمل حمایت از طرحهای پژوهشی ستاد زیست فناوری و طرح تقسیم کار ملی زیست فناوری نسبت به ارسال درخواست در سامانه طرح تقسیم کار ملی اقدام می نمایم.</b-form-checkbox>
          </b-form-group>-->

          <p>
            به ابزار ثبت طرح‌های پژوهشی سامانه تقسیم کار ملی خوش آمدید.
            خواهشمندیم ابتدا به سوالات زیر پاسخ دهید:
          </p>
          <b-form-group
            label="عنوان پایان‌نامه کارشناسی ارشد"
            :class="initial.faSubject ? 'done' : 'required'"
          >
            <b-form-input
              trim
              type="text"
              v-model="initial.faSubject"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="تاریخ ثبت پروپوزال"
            :class="initial.dateProposalSubmission ? 'done' : 'required'"
          >
            <date-picker
              color="#7b1fa2"
              v-model="initial.dateProposalSubmission"
              :editable="true"
            ></date-picker>
          </b-form-group>

          <b-form-group label="عنوان پروژه کارشناسی (در صورت وجود) ">
            <b-form-input
              trim
              type="text"
              v-model="initial.bachelorProjectSubject"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label="آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها استفاده کرده است؟"
            :class="initial.initialIsSupported !== null ? 'done' : 'required'"
          >
            <b-form-radio-group v-model="initial.initialIsSupported">
              <b-form-radio :value="true">بله</b-form-radio>
              <b-form-radio :value="false">خیر</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
          <b-form-group
            label="حمایت ها:"
            v-if="initial.initialIsSupported"
            :class="initial.initialSupportedType ? 'done' : 'required'"
          >
            <b-form-select
              class="myselect2"
              id="first"
              v-model="initial.initialSupportedType"
              :options="options"
            >
            </b-form-select>
          </b-form-group>
          <b-form-group
            label="عنوان حمایت دریافتی"
            v-if="
              initial.initialSupportedType == 'other' &&
              initial.initialIsSupported
            "
            :class="initial.initialOtherSupport ? 'done' : 'required'"
          >
            <b-form-input
              trim
              type="text"
              v-model="initial.initialOtherSupport"
            >
            </b-form-input>
          </b-form-group>
          <b-form-group
            label="توضیحات حمایت دریافتی:"
            v-if="initial.initialIsSupported"
            :class="initial.initialSupportDescription ? 'done' : 'required'"
          >
            <b-form-textarea
              trim
              rows="6"
              v-model="initial.initialSupportDescription"
            >
            </b-form-textarea>
          </b-form-group>
        </b-tab>
        <b-tab
          disabled
          :title="'اطلاعات اصلی پایان‌نامه کارشناسی ارشد'"
        ></b-tab>
        <b-tab disabled :title="'اطلاعات دانشجو'"></b-tab>
        <b-tab disabled :title="' اساتید راهنما و مشاور'"></b-tab>
        <b-tab disabled :title="' اطلاعات پروپوزال'"></b-tab>
        <b-tab disabled :title="'اطلاعات تجاری‌سازی'"></b-tab>
        <b-tab disabled :title="'زمان‌بندی'"></b-tab>
        <b-tab disabled :title="' فایل های تکمیلی'"></b-tab>
        <b-tab :title="'تعهدات'" disabled></b-tab>
        <b-tab :title="'مرور نهایی'" disabled></b-tab>
      </b-tabs>
      <div class="d-flex justify-content-center mt-3">
        <!-- <b-btn
          v-if="tabIndex != 0"
          class="mx-1"
          variant="light"
          @click="tabIndex--"
        >مرحله قبل</b-btn>-->

        <!-- NOTE (b-start) To begin the proposal registration process -->
        <b-button
          class="mx-1"
          variant="primary"
          @click="start()"
          :disabled="
            !initial.dateProposalSubmission ||
            !initial.faSubject ||
            !initial.initialObligation ||
            initial.initialIsSupported === null ||
            (initial.initialIsSupported && !initial.initialSupportedType) ||
            (initial.initialIsSupported &&
              !initial.initialSupportDescription) ||
            (initial.initialIsSupported &&
              initial.initialSupportedType == 'other' &&
              !initial.initialOtherSupport)
          "
          >آغاز فرآیند</b-button
        >
      </div>
    </b-card>

    <router-view></router-view>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import router from "../../router"; // NOTE (IMPORT) to communication between different parts of the site
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search
import GSTC from "vue-gantt-schedule-timeline-calendar";
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time

export default {
  components: {
    Select2, // NOTE (COMPONENT) component of select2 plugin
    GSTC,
    datePicker: VuePersianDatetimePicker, // NOTE (COMPONENT) component of VuePersianDatetimePicker plugin
  },
  data() {
    return {
      initial: {
        initialIsSupported: null,
      },
      tabIndex: 1,
      options: [
        { text: "طرح", value: "project" },
        { text: "پایان‌نامه ارشد", value: "master" },
        { text: "رساله دکتری", value: "phd" },
        { text: "مقالات", value: "article" },
        { text: "نشست‌ها", value: "meeting" },
        { text: "دوره‌های پسادکتری", value: "postDoc" },
        { text: "فرصت‌های مطالعاتی", value: "opportune" },
        { text: "نخبگان وظیفه", value: "elite" },
        { text: "سایر", value: "other" },
      ],
    };
  },

  methods: {
    start() {
      // NOTE (m-start) to save drafts in each step
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.$http
        .post(
          this.baseUrl + "/setad/researcher/request/master/new",
          {
            initialObligation: this.initial.initialObligation,
            faSubject: this.initial.faSubject,
            dateProposalSubmission: this.initial.dateProposalSubmission,
            initialIsSupported: this.initial.initialIsSupported,
            bachelorProjectSubject: this.initial.bachelorProjectSubject,
            initialSupportedType: this.initial.initialSupportedType,
            initialOtherSupport: this.initial.initialOtherSupport,
            initialSupportDescription: this.initial.initialSupportDescription,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          const title = (
            <div>
              <h5>!ثبت پیشنویس</h5>
              <span>
                پپیشنویس ثبت شد. برای ثبت نهایی تکمیل کلیه اطلاعات و زدن دکمه
                ارسال پایان‌نامه کارشناسی ارشد الزامی است
              </span>
            </div>
          );
          this.toast(title, "info");
          router.push("/researcher/completeMasterThesis/" + res.data);
        })
        .catch((err) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}

.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.required {
  color: red;
}

.done {
  color: green;
}
</style>
